import React from 'react';
import { RadioStatesProps } from './model/RadioStatesProps.interface';
import cls from './RadioBtn.module.css';

export function CheckedRadio({ onClick }: RadioStatesProps) {
    return (
        <span className={cls.icon}>
            <svg
                onClick={onClick}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
            >
                <g opacity="0.7" clipPath="url(#clip0_5222_1411)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.99998 2C5.90898 2 1.99997 5.91045 1.99997 10.0014C1.99997 14.0924 5.90898 18 9.99998 18C14.091 18 18 14.0924 18 10.0014C18 5.91045 14.091 2 9.99998 2ZM0.740723 10.0014C0.740723 4.8877 4.88623 0.742188 9.99998 0.742188C15.1137 0.742188 19.2592 4.8877 19.2592 10.0014C19.2592 15.1152 15.1137 19.2607 9.99998 19.2607C4.88623 19.2607 0.740723 15.1152 0.740723 10.0014Z"
                        fill="#252733"
                    />
                    <path
                        className={cls.iconCheck}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.3839 7C14.7597 7.34685 14.7308 7.47595 14.3839 7.85171L9.2557 13.4073C9.08041 13.5972 8.83375 13.7052 8.57532 13.7052C8.3169 13.7052 8.07023 13.5972 7.89495 13.4073L5.61575 10.9381C5.26889 10.5624 5.24012 10.3469 5.61588 10C5.99164 9.65316 6.15297 9.62425 6.49983 10L8.57532 12L11 9.50001L13.4998 7.00001C13.8466 6.62425 14.0081 6.65314 14.3839 7Z"
                        fill="#252733"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_5222_1411">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
}
